module.exports = __webpack_public_path__ + "static/media/MH.bfd46777.svg";